module.exports = __webpack_public_path__ + "img/pr-2.3506c3fd.png";